function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#IconHourglass_svg__clip0)",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.025 3.652C4.395 5.792 5.698 7.257 8 8c2.301-.743 3.604-2.209 3.974-4.348A1 1 0 0010.98 2.5H5.02a1 1 0 00-.994 1.152v0zM2.5.5h11M5.02 13.5a1 1 0 01-.995-1.151C4.395 10.209 5.7 8.744 8 8c2.301.744 3.604 2.21 3.975 4.349a1 1 0 01-.995 1.151H5.02zM2.5 15.5h11"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "IconHourglass_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));

function SvgIconHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgIconHourglass;